import { useDrawer } from '../context/DrawerContext';
import { useDrawerNavigation } from '../context/DrawerNavigationContext';
import useBodyScrollLock from '../hooks/useBodyScrollLock';

/**
 * DrawerScrollLock — owns page scroll-lock for the whole drawer family.
 *
 * Rendered once inside DrawerNavigationProvider (the only scope that sees both
 * the main-panel open state and the drilldown state). Locking is driven by
 * `isOpen || activeDrillDownItem !== null` so scroll stays locked as long as
 * ANY drawer surface is open — this is what prevents the double-toggle where
 * closing a drilldown would otherwise unlock scroll while the main panel is
 * still open.
 *
 * Renders nothing. `useBodyScrollLock` measures the scrollbar width before it
 * locks, so no manual scrollbar-width juggling at the call site is needed once
 * the react-bootstrap ModalManager (which did that automatically) is gone.
 *
 * @returns {null}
 */
const DrawerScrollLock = () => {
	const { isOpen } = useDrawer();
	const { activeDrillDownItem } = useDrawerNavigation();

	useBodyScrollLock(isOpen || activeDrillDownItem !== null);

	return null;
};

export { DrawerScrollLock };
